var _rect, _path, _path2, _path3, _path4, _path5, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPerk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39.1936,
    rx: 3.5,
    fill: "url(#paint0_linear_4766:83902)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2021 16.4707H12.8942C12.4004 16.4707 12 16.8711 12 17.3649V19.1534C12 19.6473 12.4004 20.0477 12.8942 20.0477H27.2021C27.696 20.0477 28.0963 19.6473 28.0963 19.1534V17.3649C28.0963 16.8711 27.696 16.4707 27.2021 16.4707Z",
    stroke: "#FFA000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0483 16.4707V28.0958",
    stroke: "#FFA000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3081 20.0488V26.3085C26.3081 26.7828 26.1196 27.2377 25.7842 27.5732C25.4488 27.9086 24.9939 28.097 24.5196 28.097H15.5772C15.1028 28.097 14.6479 27.9086 14.3125 27.5732C13.9771 27.2377 13.7887 26.7828 13.7887 26.3085V20.0488",
    stroke: "#FFA000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0243 16.4716C15.4314 16.4716 14.8627 16.2361 14.4435 15.8168C14.0242 15.3975 13.7887 14.8289 13.7887 14.236C13.7887 13.6431 14.0242 13.0744 14.4435 12.6552C14.8627 12.2359 15.4314 12.0004 16.0243 12.0004C16.887 11.9854 17.7323 12.4039 18.4501 13.2015C19.1679 13.9991 19.7249 15.1386 20.0484 16.4716C20.3718 15.1386 20.9288 13.9991 21.6466 13.2015C22.3644 12.4039 23.2098 11.9854 24.0725 12.0004C24.6654 12.0004 25.234 12.2359 25.6533 12.6552C26.0725 13.0744 26.3081 13.6431 26.3081 14.236C26.3081 14.8289 26.0725 15.3975 25.6533 15.8168C25.234 16.2361 24.6654 16.4716 24.0725 16.4716",
    stroke: "#FFA000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.625 36.1936C14.9228 36.1936 11.6305 34.9411 9.04462 32.5216C5.8229 29.5186 3.98595 24.9643 4.00008 20.0114C4.01421 15.7132 5.68159 11.6855 8.70548 8.66821C11.7152 5.65095 15.7141 4 19.9532 4C19.9674 4 19.9956 4 20.0098 4C23.7684 4.01423 27.4141 5.18129 30.2684 7.30191C31.0597 7.88543 31.2292 8.99556 30.6499 9.79257C30.0706 10.5896 28.9684 10.7604 28.1771 10.1768C25.9162 8.49743 23.0054 7.57232 19.9956 7.55809C19.9815 7.55809 19.9674 7.55809 19.9532 7.55809C16.6467 7.55809 13.5381 8.85323 11.2066 11.1873C8.84679 13.5357 7.5468 16.681 7.53267 20.0256C7.51854 23.9822 8.9457 27.583 11.4468 29.9171C13.6228 31.9381 16.4913 32.8632 19.7554 32.5928C27.626 31.9381 32.3455 27.2699 32.3738 20.111C32.3738 20.0399 32.3738 19.9829 32.3879 19.9118C32.6282 17.8196 32.3314 15.884 31.4977 14.1477C31.0738 13.2653 31.4553 12.1978 32.3314 11.7709C33.2075 11.3439 34.2673 11.7282 34.6912 12.6106C35.7934 14.9305 36.2031 17.4923 35.9064 20.2107C35.864 24.5658 34.3945 28.3373 31.6249 31.1553C28.8271 34.0018 24.8282 35.7239 20.0521 36.1224C19.5717 36.1794 19.0913 36.1936 18.625 36.1936Z",
    fill: "#FFA000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39.1936,
    rx: 3.5,
    stroke: "#F2F2F2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4766:83902",
    x1: 0,
    y1: 0,
    x2: 40.1931,
    y2: 39.9995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerk);
export default __webpack_public_path__ + "static/media/perk.7e8962057d9d6b72786e3ae6d65641be.svg";
export { ForwardRef as ReactComponent };